export const REGISTER = '/register';
export const LOGIN = '/login';

export const HOME = '/';
export const TRANSACTIONS = '/transactions';
export const ACCOUNTS = '/';
export const PROFILE = '/profile';
export const CATEGORIES = '/categories';
export const REPORTS = '/reports';
